module.exports = __webpack_public_path__ + "static/media/2.4590fe93.jpg";